import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InsightsService } from '../Insights/insights.service';
import { getAppConfig } from 'src/app.config';
import { Observable } from 'rxjs';
import {map} from 'rxjs/operators'
import { apiConstants } from '../../constants/endpoints';
import { environment } from 'src/environments/environment'; 

const appSettings = getAppConfig() as any;

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  apiURL: string;
  hoptions = {
    headers: new HttpHeaders()
  };
  

  constructor(private http: HttpClient, private insights: InsightsService) {
    this.apiURL = environment.apiURL;
  }

  public get(url: string, options?: any):Observable<any> {
    this.insights.trackEvent(
      'CD Support-Http Service Component-GET Method called',
      { url }
    );
    return this.http.get(this.apiURL + url);
  }
  public post(url: string, data: any, options?: any) {
    this.insights.trackEvent(
      'CD Services-Http Service Component-Post Method called',
      { url, data }
    );
    return this.http.post(this.apiURL + url, data, this.hoptions);
  }
  public put<T>(url: string, data: any, options?: any) {
    return this.http.put<T>(this.apiURL + url, data, options)
    .pipe(map(r=>r as T));
  }

  public patch<T>(url: string, data: any, options?: any) {
    return this.http.patch<T>(this.apiURL + url, data, options)
    .pipe(map(r=>r as T));
  }

  public delete<T>(url: string, options?: any):Observable<T> {
    return this.http.delete<T>(this.apiURL + url, options)
    .pipe(map(r=> r as T));
  }

  public uploadFile(fileData: any, isOverridden: boolean = false) {
    let url = `${this.apiURL}blob-storage/upload`;
    const httpOptions = {
      headers: new HttpHeaders({
        'enctype': 'multipart/form-data',
        'Accept': 'application/json'
      })
    };
    if (isOverridden) {
      url = `${this.apiURL}blob-storage/package-override`;

    }
    else {
      url = `${this.apiURL}blob-storage/upload`;
    }
    return this.http.post<any>(url, fileData, httpOptions);

  }
}
